/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

import { LOCALES } from './types';

export enum PROD_SUPPORTED_LOCALES {
  en_ca = LOCALES.en_ca,
  en_us = LOCALES.en_us,
  fr_ca = LOCALES.fr_ca,
}
